import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Box,
  Typography,
  Button,
} from '@mui/material'

import { Add, Close } from '@mui/icons-material'
import {
  useBonusDialog,
  useExcludedGamesActions,
} from '@/views/bonus-engine/hooks'
import { DialogsEnum } from '@/enums'

import { ExcludedGamesTableComponent } from './'

export const ExcludedGamesDialog = () => {
  const { t } = useTranslation()

  const { dialogs, toggleDialog } = useBonusDialog()

  const { getExcludedGames, resetGamesListAction } = useExcludedGamesActions()

  const listDialogs = [
    DialogsEnum.DIALOG_EXCLUDED_GAMES,
    DialogsEnum.DIALOG_EXCLUDED_GAMES_FORM,
  ]

  useEffect(() => {
    getExcludedGames({})
    return () => {
      resetGamesListAction()
    }
  }, []) // eslint-disable-line

  const handleCloseDialog = () => {
    toggleDialog(false, DialogsEnum.DIALOG_EXCLUDED_GAMES)
  }

  const addNewGame = () => {
    toggleDialog(true, DialogsEnum.DIALOG_EXCLUDED_GAMES_FORM)
  }

  return (
    <Dialog
      open={
        dialogs.findIndex(
          (dialog) =>
            dialog.open &&
            listDialogs.findIndex((id) => id === dialog.id) !== -1,
        ) !== -1
      }
      aria-labelledby="dialog-title"
      fullWidth
      sx={{
        '& .MuiDialog-paperFullWidth': {
          width: '800px',
          maxWidth: '100%',
        },
      }}
    >
      <DialogTitle id="dialog-title">
        <Box mb={1} display="flex" justifyContent="space-between" width="100%">
          <Typography fontWeight={700} variant="h5" sx={{ mt: 0.5, pl: 1 }}>
            {t('labels.excludedGames')}
          </Typography>
          <Box display="flex" alignItems="center">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="small"
              startIcon={<Add />}
              onClick={() => addNewGame()}
              sx={{ height: '30px', mr: 2 }}
            >
              {t('labels.add')}
            </Button>
            <IconButton onClick={handleCloseDialog}>
              <Close />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <ExcludedGamesTableComponent />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}
